export const emailValidator =
  <TData extends { email: string }>(users: TData[] | undefined) =>
  (value: string) => {
    if (!users) return undefined;

    if (users.some((user) => user.email === value)) {
      return "The email is already taken";
    }

    return undefined;
  };
